/* eslint-disable no-unused-vars */

import { NavBar } from "../../components/NavBar";
import { useContext, useEffect, useState } from "react";
import { api } from "../../api/api";
import { DateTime } from "luxon";
import { FaSearch, FaStar } from "react-icons/fa";
import { FiExternalLink, FiMessageSquare, FiSearch, FiStar } from "react-icons/fi";
import { ModalOrders } from "../../components/Modals/Orders";
import { useDispatch } from "react-redux";
import { SELECT_ORDER } from "../../stores/reducers/OrderReducers";
import { GlobalContext } from "../../context/GlobalContext";
import '../admin.css'

export function RatingOrdersPage () {
  const dispatch = useDispatch()
  const { openModalOrder } = useContext(GlobalContext)
  const [ratings, setRatings] = useState([])
  const [ratingOrderAvg, setRatingOrdersAvg] = useState(0)
  const [link, setLink] = useState('')
  const [loadding, setLoadding] = useState(false)
  const [filter, setFilter] = useState({
    startDate: '',
    endDate: '',
    phone: ''
  })

  async function search () {
    setLoadding(true)
    api.get(`/rating-order?startDate=${filter.startDate}&endDate=${filter.endDate}&phone=${filter.phone}`)
      .then(async (res) => {
        const response = await api.get('/companies/generate/link')
        setLink(response.data)
        setRatings(res.data)
      }).finally(() => setLoadding(false))
  }


  async function avgRatingOrders () {
    const response = await api.get(`/rating-order/rating/avg`)

    setRatingOrdersAvg(response.data.avg)
  }

  function returnStarRender (score = 0) {
    const elements = []
    for (let index = 0; index < score; index++) {
      elements.push(<FaStar key={index} color="#FFB020" />)
    }
    return elements
  }

  async function openOrder (id) {
    const response = await api.get(`/orders/${id}`)

    dispatch(SELECT_ORDER(response.data))
    openModalOrder()
  }

  useEffect(() => {
    search()
    avgRatingOrders()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <>
      <NavBar>
        <main className="admin-page ratings-page">
          <header className="admin-page-header"><div><h1>Avaliações</h1><p>Acompanhe a experiência dos clientes após cada pedido</p></div></header>

          <section className="admin-surface ratings-filter-surface">
            <div className="admin-filter-bar ratings-filters">
                <label><span>Data inicial</span>
                  <input onChange={(e) => setFilter(state => {
                    return {
                      ...state,
                      startDate: DateTime.fromSQL(e.target.value).startOf('day').toSQLDate(),
                    }
                  })} type="date" />
                </label>
                <label><span>Data final</span>
                  <input onChange={(e) => setFilter(state => {
                    return {
                      ...state,
                      endDate: DateTime.fromSQL(e.target.value).endOf('day').toSQLDate()
                    }
                  })} type="date" />
                </label>
              <label><span>Telefone</span>
                <input type="text" onChange={(e) => setFilter(state => {
                  return {
                    ...state,
                    phone: e.target.value,
                  }
                })} placeholder="Telefone do cliente" />
              </label>
              <button className="admin-primary-button" onClick={search}><FiSearch /> Pesquisar</button>
              <div className="rating-average"><span><FiStar /></span><div><small>Avaliação média</small><strong>{Number(ratingOrderAvg || 0).toFixed(1)}</strong><div>{returnStarRender(ratingOrderAvg)}</div></div></div>
            </div>
          </section>

          <section className="admin-surface">
            <div className="admin-surface-header"><div><h2>Avaliações recebidas</h2><p>{ratings.length} avaliações encontradas</p></div><FiMessageSquare size={19} /></div>
          <div className="admin-table-wrap">
            <table className="admin-table">
              <thead>
                <tr>
                  <th>Pedido</th>
                  <th>Data</th>
                  <th>Comentario</th>
                  <th>Avaliação</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                {!loadding && (
                  <>
                    {ratings.map((rating, index) => {
                      return (
                        <tr key={index}>
                          <td data-label="Pedido">
                            <a target="_blank" href={`${link}/${rating.idOrder}`} rel="noreferrer">#Pedido <FiExternalLink /></a>
                          </td>
                          <td data-label="Data">{DateTime.fromISO(rating.createdAt).toFormat('dd/MM/yyyy HH:mm')}</td>
                          <td data-label="Comentário">{rating.comment || 'Sem comentário'}</td>
                          <td data-label="Avaliação"><span className="rating-score">{returnStarRender(rating.score)} <strong>{rating.score}</strong></span></td>
                          <td data-label="Ações">
                            <button className="admin-icon-button" onClick={() => openOrder(rating.idOrder)} aria-label="Abrir pedido"><FaSearch /></button>
                          </td>
                        </tr>
                      )
                    })}
                  </>
                )}
              </tbody>
            </table>
            {!loadding && ratings.length === 0 && <div className="admin-empty"><FiStar size={25} /><strong>Nenhuma avaliação encontrada</strong><span>Ajuste os filtros e tente novamente.</span></div>}
          </div>
          </section>

          {loadding && (
            <div className="admin-loading">
              <span>Carregando avaliações</span>
              <div className="spinner-border mb-2" role="status">
                <span className="visually-hidden">Loading...</span>
              </div>
            </div>
          )}
        </main>
      </NavBar>
    </>
  )
}


